import type { IErrorResponse } from '../models/error-response.model';
import { IServiceBaseError } from '../services/service-base.service';

export class ErrorHandlerHelper {
  public static mapErrorToIErrorResponse(error: IServiceBaseError): IErrorResponse {
    return {
      statusCode: error?.httpStatusCode ?? 500, // Set default to 500 if no status code is available
      errorCode: error?.errorCode,
      errorLevel: undefined,
      errorMessage: undefined,
    };
  }

  public static isErrorReponse(obj: unknown): obj is IErrorResponse {
    if (typeof obj !== 'object' || obj === null) {
      return false;
    }
    const obj2 = obj as IErrorResponse;
    return obj2.statusCode !== undefined && typeof obj2.statusCode === 'number';
  }
}
